<template>
  <div class="tiktok-container-light">
    <v-btn elevation="4" class="back-button" @click="$router.push('/')" fab small color="rgba(255, 255, 255, 0.7)">
      <v-icon color="black">mdi-chevron-left</v-icon>
    </v-btn>

    <v-img class="hero-image" height="90vh" src="https://app.wellcomefit.ch/img/einmalig/alibey/slider/alibeySlider6.jpg" cover>
      <div class="scrim-overlay d-flex flex-column justify-center align-center text-center">
        <v-img class="mt-12" contain max-height="100px" src="https://app.wellcomefit.ch/img/logos/studio/WELL-COME-FIT_LOGO_WHITE.png"></v-img>

        <div class="tiktok-title-container">
          <h2 class="event-location">Ali Bey Club Manavgat, Antalya</h2>
          <p class="event-date">30. MAI 2026 – 06. JUNI 2026</p>
        </div>

        <div class="event-description">
          Sonne, Meer und ganz viel Fitness! <br />
          Der Mix aus Sport, Gesundheit, Party und Erholung macht dieses Event zu einem unvergleichlichen Erlebnis für Dich, Deine Freunde und Deine
          Familie!
        </div>

        <div class="scroll-indicator" @click="scrollToContent">
          <span>Mehr Infos</span>
          <v-icon color="white" class="bounce-animation">mdi-arrow-down</v-icon>
        </div>
      </div>
    </v-img>

    <div class="content-below-fold" ref="contentSection">
      <div class="info-section">
        <h3 class="section-title"><span>🔥</span> Das ist alles drin!</h3>
        <v-container fluid>
          <v-row>
            <v-col cols="6" md="4" v-for="(feature, i) in features" :key="i">
              <div class="feature-card">
                <v-icon class="feature-icon" color="primary">{{ feature.icon }}</v-icon>
                <p class="feature-text">{{ feature.text }}</p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div class="info-section advantages text-center">
        <h3 class="section-title"><span>💪</span> Deine Vorteile</h3>
        <p><v-icon color="green" class="mr-2">mdi-check-bold</v-icon>Individuelle Trainings- & Ernährungsberatung</p>
        <p><v-icon color="green" class="mr-2">mdi-check-bold</v-icon>Exklusives Trainer-Netzwerk</p>
        <p><v-icon color="green" class="mr-2">mdi-check-bold</v-icon>Einzigartige Community vor Ort</p>
      </div>

      <div class="info-section flight-info">
        <h3 class="section-title"><span>✈️</span> Flugempfehlung</h3>

        <h4 class="font-weight-bold text-center black--text">Hinflüge</h4>
        <p class="flight-details"><strong class="orange--text">Sunexpress:</strong> 30.05.26 | 09:40 ZRH</p>
        <p class="flight-details"><strong class="red--text">Edelweiss:</strong> 30.05.26 | 05:45 ZRH</p>
        <v-divider></v-divider>
        <h4 class="font-weight-bold text-center black--text">Rückflüge</h4>
        <p class="flight-details"><strong class="orange--text">Sunexpress:</strong> 06.06.26 | 06:10 AYT</p>
        <p class="flight-details"><strong class="orange--text">Sunexpress:</strong> 06.06.26 | 14:55 AYT</p>
        <p class="flight-details"><strong class="red--text">Edelweiss:</strong> 06.06.26 | 10:55 ZRH</p>

        <v-btn class="mt-2 sunexpress-btn mx-2" outlined @click="openSunExpress">
          <v-icon left>mdi-airplane-takeoff</v-icon>
          SunExpress
        </v-btn>
        <v-btn class="mt-2 edelweiss-btn mx-2" outlined @click="openEdelweiss">
          <v-icon left>mdi-airplane-takeoff</v-icon>
          Edelweiss
        </v-btn>
      </div>

      <div class="info-section">
        <h3 class="section-title"><span>🍹</span> Ultra All-Inclusive</h3>
        <v-expansion-panels class="expansion-panels-glowup" flat>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header">Ohne Gebühr</v-expansion-panel-header>
            <v-expansion-panel-content class="panel-content">
              Minibar, 24h Markeneiscreme, alle Softdrinks, frische Säfte, Sekt, Energy Drinks, Cocktails, Import-Alkohol (z.B. Chivas, Absolut,
              Havana), Türkischer Kaffee & Hammam, WLAN, Aquapark, Beach Volleyball u.v.m.
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header">Gegen Gebühr</v-expansion-panel-header>
            <v-expansion-panel-content class="panel-content">
              Premiumgetränke, diverse Weinsorten, Tennisplätze und Kurse, Padel-Tennisplätze, Tennisausrüstung, Billard, Arcade-Spiele, Massage,
              VIP-Hammam, Arzt, Geschäfte, Wäsche Service, Friseur, Fotograf, Kinderwagenverleih, Fitness First (für Mitglieder kostenlos),
              Wassersportmöglichkeiten (Fremdanbieter), Telefon, Panorama A la Carte Restaurant, Teppanyaki A la Carte Restaurant, Pavillonservice am
              Strand, Mini Golf (mit Vorreservierung) und Kletterpark (mit Vorreservierung)
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <div class="info-section drinks-info">
        <h4 class="info-subtitle">Upgrade von All-Inclusive zu <strong>Ultra All-Inclusive</strong></h4>
        <p class="info-text">
          <strong>Bisher (AI):</strong> Alle nicht alkoholischen Getränke (Ausnahme: Energy Drink) und alle lokalen alkoholischen Getränke (Ausnahme:
          Weinsorten), frisch gepresster Orangensaft und Grapefruitsaft beim Frühstück.
        </p>
        <p class="info-text">
          <strong><span class="primary--text">NEU (UA):</span></strong> Zusätzlich alle Import Getränke (Ausnahme: einige Premiumgetränke),
          Sekt/Champagner und Energy Drinks.
        </p>
        <v-divider class="my-4"></v-divider>
        <h4 class="info-subtitle">Einige Marken-Beispiele (UA)</h4>
        <p class="info-text brand-list">
          <strong>Bier:</strong> Heineken, Becks, Miller, Bomonti | <strong>Wodka:</strong> Absolut, Smirnoff, Ketel One |
          <strong>Whiskey:</strong> Chivas Regal 12 Yrs, Ballantine’s 12 Yrs, Jack Daniels, Jim Beam, Johnnie Walker Black Label 12 Yrs, Johnnie
          Walker Red Label, The Glenlivet Founder’ Reserve | <strong>Gin:</strong> Beefeater, Gordon’s London Dry | <strong>Rum:</strong> Bacardi,
          Havana Anejo 3 Anos, Captain Morgan Black | <strong>Tequila:</strong> Olmeca Gold, El Jimador | <strong>Liquer:</strong> Jagermeister,
          Amaretto, Malibu, Baileys, Frenet Branca, Liquer 43, Ramazotti | <strong>Digestive:</strong> Campari, Martini (Bianco, Rosso, Extra Dry)
        </p>
      </div>
    </div>

    <v-snackbar v-model="snackbar">Du hast bereits eine Buchung erstellt.</v-snackbar>
  </div>
</template>

<script>
// Der Script-Bereich bleibt unverändert
import api from "../../api"
import { mapGetters, mapActions } from "vuex"

export default {
  name: "aliBey",
  data() {
    return {
      hasListEntry: false,
      snackbar: false,
      features: [
        { icon: "mdi-bed", text: "7 Nächte im Top-Zimmer" },
        { icon: "mdi-airport", text: "Transfer Hotel/Flughafen" },
        { icon: "mdi-star-circle", text: "ULTRA All-Inclusive" },
        { icon: "mdi-weight-lifter", text: "Tägliche Groupfitness" },
        { icon: "mdi-party-popper", text: "Wellcome Party & Gala" },
        { icon: "mdi-account-group", text: "Betreuung durch unser Team" },
      ],
    }
  },
  created() {
    api.checkListEntry("alibey").then((data) => (this.hasListEntry = data))
    this.setNavigationBarText({ text: "RESERVATION", state: false, color: "alibey" })
  },
  computed: {
    ...mapGetters("navigationStoreNotPersisted", ["navigationBarTextState"]),
  },
  methods: {
    ...mapActions("navigationStoreNotPersisted", ["setNavigationBarText"]),
    openSunExpress() {
      window.open("https://sunexpress.com", "__blank")
    },
    openEdelweiss() {
      window.open("https://www.flyedelweiss.com/ch/de/home.html", "__blank")
    },
    pushToBookingPage() {
      this.$router.push({ name: "AliBeyBooking" })
      this.snackbar = true
    },
    scrollToContent() {
      this.$refs.contentSection.scrollIntoView({ behavior: "smooth" })
    },
  },
  watch: {
    async navigationBarTextState(value) {
      value && this.pushToBookingPage()
    },
  },
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;700;900&display=swap");

/* Hauptcontainer jetzt hell */
.tiktok-container-light {
  background-color: #f7f9fc;
  color: var(--v-alibey);
  font-family: "Poppins", sans-serif;
  height: 100vh;
  width: 100vw;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

.back-button {
  position: fixed;
  top: 15px;
  left: 15px;
  z-index: 10;
}

/* Overlay auf dem Bild bleibt dunkel für Textkontrast */
.hero-image .scrim-overlay {
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 20%, rgba(0, 0, 0, 0.1) 60%);
  padding: 20px;
  color: #ffffff;
}

.tiktok-title-container {
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.8);
  margin-top: 2rem;
  .event-location,
  .event-date {
    font-weight: bold;
    font-size: 1.2rem;
  }
}

.event-description {
  margin-top: 2rem;
  font-size: 1.1rem;
  max-width: 600px;
}

.scroll-indicator {
  position: absolute;
  bottom: 2rem;
  cursor: pointer;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 700;
  .bounce-animation {
    animation: bounce 2s infinite;
  }
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-15px);
  }
  60% {
    transform: translateY(-8px);
  }
}

.content-below-fold {
  margin-top: -10vh; /* Sorgt für einen schönen Übergangseffekt */
  padding: 20px 15px 40px 15px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-color: #f7f9fc;
  position: relative;
  z-index: 2;
}

.info-section {
  background-color: #ffffff;
  border-radius: 20px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* Moderner Schatten */

  &.advantages p {
    font-size: 1.1rem;
    margin-bottom: 8px;
    color: #333;
  }
}

.section-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
  color: var(--v-alibey);
  span {
    margin-right: 10px;
  }
}

.feature-card {
  text-align: center;
  padding: 1rem 0.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f7f9fc;
  border-radius: 15px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  }
}

.feature-icon {
  font-size: 2.5rem !important;
  margin-bottom: 0.75rem;
}
.feature-text {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.3;
  color: #333;
  margin-bottom: 0;
}

.flight-info {
  text-align: center;
  .flight-details {
    color: black;
    font-size: 1.1rem;
  }
  .sunexpress-btn {
    border-color: #ff8c00;
    color: #ff8c00;
    font-weight: 700;
  }
  .edelweiss-btn {
    border-color: red;
    color: red;
    font-weight: 700;
  }
}

.expansion-panels-glowup {
  .v-expansion-panel {
    background-color: #f7f9fc !important;
    margin-bottom: 10px;
    border-radius: 15px !important;
  }
  .panel-header {
    font-weight: 700;
    font-size: 1.1rem;
  }
  .panel-content {
    padding-top: 15px;
    font-size: 1rem;
  }
}

.drinks-info {
  .info-subtitle {
    font-size: 1.2rem;
    font-weight: 700;
    text-align: center;
    margin-bottom: 1rem;
  }
  .info-text {
    font-size: 1rem;
    color: #555;
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto 1rem auto;
    text-align: center;
  }
  .brand-list {
    font-size: 0.9rem;
    color: #777;
    strong {
      color: #333;
    }
  }
}

.final-actions {
  text-align: center;
  margin-top: 2rem;
  padding: 1rem 0;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 1rem;
}

.book-now-btn {
  font-weight: 700;
  font-size: 1.2rem;
  box-shadow: 0px 5px 20px rgba(var(--v-primary-base), 0.4);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
</style>
